function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M6 6h20v20H6z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 10,
  fill: "#FCB243"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.09 20.5l-.817-3.515L21 14.622l-3.596-.309L16 11l-1.405 3.313-3.595.309 2.727 2.363-.817 3.515L16 18.636l3.09 1.864z",
  fill: "#fff"
});

var SvgIconStudentStatusStar = function SvgIconStudentStatusStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA2KSIvPgo8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxMCIgZmlsbD0iI0ZDQjI0MyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjA5IDIwLjVMMTguMjcyNSAxNi45ODU1TDIxIDE0LjYyMkwxNy40MDQ1IDE0LjMxMzVMMTYgMTFMMTQuNTk1NSAxNC4zMTM1TDExIDE0LjYyMkwxMy43Mjc1IDE2Ljk4NTVMMTIuOTEgMjAuNUwxNiAxOC42MzZMMTkuMDkgMjAuNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconStudentStatusStar as ReactComponent };